export default "__VITE_ASSET__DZjKWj$u__"